import React from "react";
import GenericModalContainer from "../Modals/GenericModalContainer";
import { MemberWithState } from "../../types";
import Button from "../../components/Layout/Button";

interface DeleteConfirmationProps {
    close: () => void;
    member: MemberWithState;
    index: number;
    onDelete: (member: MemberWithState, index: number) => void;
}

const DeleteConfirmation: React.FC<DeleteConfirmationProps> = ({
    close,
    member,
    index,
    onDelete,
}) => {
    return (
        <GenericModalContainer
            close={close}
            headingText={`Are you sure you want to delete ${member.name}?`}
            backButton={() => close()}
            removal={true}
        >
            <div className="buttons">
                <Button
                    loading={0}
                    className="btn simple"
                    onClick={close}
                    style={{ fontWeight: "600" }}
                >
                    Cancel
                </Button>
                <Button
                    loading={0}
                    className="btn simple primary"
                    type="submit"
                    style={{ fontWeight: "600" }}
                    onClick={() => {
                        onDelete(member, index);
                    }}
                >
                    Yes
                </Button>
            </div>
        </GenericModalContainer>
    );
};
export default DeleteConfirmation;
